import { FC, useEffect, useState } from "react";
import { useLazyGetIPAdressQuery } from "./IPAdressApi";
import { IIPAddressProps } from "./IIPAddressProps";
import { ProgressIndicator } from "../../../widgets";

const usePublicIP = () => {
    const [IPAddress, setIPAddress] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getPublicIP()
            .then((ip) => {
                setIPAddress(ip);
            })
            .catch((error) => {
                console.error("Error fetching IP:", error);
            });
    }, []);

    function getPublicIP() {
        setLoading(true)
        return fetch('https://api.ipify.org?format=json')
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data: any) => {
                return data.ip;
            }).finally(() => setLoading(false));
    }

    return { IPAddress, loading };
};

export interface IVerificationProps extends IIPAddressProps {
    children?: React.ReactNode;
}

export const IPFilter: FC<IVerificationProps> = ({
    children
}) => {
    const { IPAddress, loading } = usePublicIP();
    const [serverIPAddress, setServerIPAddress] = useState<string>('');
    const [error, setErrorMessage] = useState<string>('');
    const [getServerIPAddress] = useLazyGetIPAdressQuery()

    useEffect(() => {
        if (!IPAddress) return;

        getServerIPAddress(
            IPAddress
        ).unwrap()
            .then((result) => {
                if (result) {
                    setServerIPAddress(result.ip);
                } else {
                    setErrorMessage("Attendance can only be marked via Campus wi-fi, hence please switch to the appropriate campus network connection.");
                }
            })
            .catch((err) => {
                setErrorMessage("Attendance can only be marked via Campus wi-fi, hence please switch to the appropriate campus network connection.")
            });
    }, [getServerIPAddress, IPAddress]);

    if (loading) {
        return <ProgressIndicator />;
    }

    if (IPAddress === serverIPAddress) {
        return <>{children}</>;
    }

    return (
        <div className="alert alert-danger">{error}</div>
    );
};
